import { FormEvent, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import KtzhBackdrop from '../../components/auth/ktzh-backdrop.component';
import { useAuth } from '../../contexts/auth.context';
import emblem from '../../assets/images/ktzh-emblem.png';
import classes from './styles.module.scss';

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthed, loading } = useAuth();
  const [username, setUsername] = useState('azamat');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const redirectTo = (location.state as { from?: string } | null)?.from || '/files';

  useEffect(() => {
    if (!loading && isAuthed) {
      navigate(redirectTo, { replace: true });
    }
  }, [isAuthed, loading, navigate, redirectTo]);

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(username, password);
      navigate(redirectTo, { replace: true });
    } catch {
      setError('Неверный логин или пароль');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={classes.public}>
      <KtzhBackdrop />
      <div className={classes.center}>
        <div className={classes.brandBlock}>
          <div className={classes.emblemWrap}>
            <img src={emblem} alt="ҚТЖ" className={classes.emblem} />
          </div>
          <div className={classes.brandTitle}>aivox</div>
          <div className={classes.brandSub}>ҚАЗАҚСТАН ТЕМІР ЖОЛЫ</div>
        </div>

        <form className={classes.card} onSubmit={onSubmit}>
          <div className={classes.cardTitle}>Вход в систему</div>
          <div className={classes.cardSub}>Корпоративная учётная запись</div>

          <label className={classes.field}>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Логин"
              autoComplete="username"
              required
            />
          </label>

          <label className={classes.field}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Пароль"
              autoComplete="current-password"
              required
            />
          </label>

          {error ? <div className={classes.error}>{error}</div> : null}

          <button type="submit" className={classes.submit} disabled={submitting}>
            {submitting ? 'Вход…' : 'Войти'}
          </button>

          <Link to="/" className={classes.aboutLink}>О платформе →</Link>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
